import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { CreativeWork, OpinionNewsArticle } from "schema-dts";

import { useArticleSchemaContext } from "~/components/article/article-schema/contexts";
import type { SwGCompatibleSchema } from "~/components/article/article-schema/types";

type Props = Record<string, never>;

export const OpinionNewsArticleSchema: FunctionComponent<Props> = () => {
  const { schemaData } = useArticleSchemaContext();

  return schemaData ? (
    <JsonLd<SwGCompatibleSchema<CreativeWork, OpinionNewsArticle>>
      item={{
        "@context": "https://schema.org",
        "@type": ["CreativeWork", "OpinionNewsArticle"],
        ...schemaData,
      }}
    />
  ) : null;
};

OpinionNewsArticleSchema.displayName = "OpinionNewsArticleSchema";
